export default __webpack_public_path__ + "static/media/undo.e588dbac.svg";